<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">
        <div v-if="selectedFolder==null">
          {{$route.meta.title}}
        </div>
        <el-breadcrumb v-else
                       separator="/">
          <el-breadcrumb-item>
            <a @click="back"
               class="is-link"
               href="javascript:;">{{$route.meta.title}}</a>
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{ selectedFolder.Name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </template>
      <template slot="btn">
        <el-dropdown v-show="selectedFolder==null"
                     @command="handleAddCommand"
                     v-has="'Upload'">
          <el-button type="primary"
                     size="medium">
            {{$t('documents.Add')}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">{{$t('documents.UploadFiles')}}</el-dropdown-item>
            <el-dropdown-item command="2">{{$t('documents.AddFolder')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-show="selectedFolder!=null"
                   type="primary"
                   v-has="'Upload'"
                   @click="openUpload"
                   size="medium">
          {{$t('documents.UploadDocument')}}
        </el-button>
      </template>
      <template slot="search">
        <el-row :gutter="20">
          <el-col :lg="8"
                  :md="6"
                  :sm="6"
                  :xs="6">
            <el-input :placeholder="$t('documents.SearchDocumentName')"
                      size="mini"
                      clearable
                      @change="getFileList()"
                      v-model="condition.FileName"></el-input>
          </el-col>
          <SortControl @sortList="sortList"
                       :orderBy="sortValue">
            <template slot="sort">
              <el-select size="mini"
                         @change="sort"
                         placeholder="Orderby"
                         v-model="sortBy">
                <el-option v-for="item in sortType"
                           :key="item.name"
                           :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </template>
          </SortControl>
        </el-row>
      </template>
    </sub-header>
    <div class="main"
         v-loading="loading">
      <div class="tool-btn">
        <el-checkbox :indeterminate="isIndeterminate"
                     v-model="checkAll"
                     :disabled="list.length == 0"
                     @change="handleCheckAllChange"> {{$t('photo.SelectAll')}}</el-checkbox>
        <span style="margin-left:15px;">
          <el-button type="primary"
                     @click="downloadDocuments"
                     size="mini"
                     :disabled="checkList.length <1 "> {{$t('photo.Download')}}</el-button>
          <el-button type="danger"
                     @click="deleteDocuments"
                     size="mini"
                     v-has="'Upload'"
                     :disabled="checkList.length < 1  "> {{$t('photo.Delete')}}</el-button>
        </span>
      </div>
      <div class="list-box">
        <myScroll style="width:100%;height:100%">
          <el-checkbox-group v-model="checkIdList"
                             @change="handleCheckedChange">
            <div class="cube-box"
                 v-for="(i,j) of list"
                 :key="i.DocFileId">
              <div class="photo-box"
                   :ref="'photobox'+j"
                   :draggable="!i.IsFolder"
                   @dragstart="handleDragStart($event, i)"
                   @dragover.prevent="handleDragOver($event, i)"
                   @dragenter="handleDragEnter($event, i)"
                   @drop="handleDragDrop($event, i)"
                   @dragend="handleDragEnd($event, i)">
                <div class="photo-img"
                     :style="{cursor: i.Type >=1 || i.IsFolder ? 'pointer': 'default'}"
                     @click="handleDocumentClick(i)">
                  <div v-if="i.Type === 2"
                       class="videoPlayContent">
                    <div class="videoPlayDiv"><span class="videoPlay"></span></div>
                    <img style="width:100%;"
                         :src="i.videoThumbUrl" />
                  </div>
                  <img v-else-if="i.Type === 1"
                       :src="i.url"
                       alt="">
                  <img v-else-if="i.Type === 3 && i.docCoverUrl"
                       :src="i.docCoverUrl"
                       style="width: 110px;">
                  <img v-else
                       style="width: 110px;"
                       :src="require('../../../assets/image/file_type/'+ $config.getIconForFileType(i.Name, i.IsFolder))">
                </div>
                <el-checkbox :label="i.DocFileId">
                  <span>{{i.Name}}</span>
                  <span>{{i.CreatedOn}}</span>
                </el-checkbox>
                <div class="action-btn"
                     v-has="'Upload'">
                  <el-dropdown @command="handleRenameDeleteCommand"
                               trigger="click">
                    <el-button type="primary">
                      <i class="el-icon-more"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{action:i.IsFolder?1:3, item:i}">
                        <el-link :underline="false">{{$t('documents.Rename')}}</el-link>
                      </el-dropdown-item>
                      <el-dropdown-item v-if="!i.IsFolder"
                                        :command="{action:4, item:i}">
                        <el-link :underline="false">{{$t('documents.Move')}}</el-link>
                      </el-dropdown-item>
                      <el-dropdown-item :command="{action:2, item:i}">
                        <el-link :underline="false"
                                 type="danger">{{$t('documents.Delete')}}</el-link>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </el-checkbox-group>
          <div v-if="list.length === 0"
               class="no-data">
            {{$t('photo.NoData')}}
          </div>
        </myScroll>
      </div>
      <page ref="pagination"
            :total="total"
            :PageSize="condition.PageSize"
            :PageIndex="condition.PageIndex"
            @handleCurrentChange="handleCurrentChange"></page>
    </div>
    <el-dialog :title="folderDialogTitle"
               :close-on-click-modal="false"
               :show-close="false"
               :visible.sync="saveFolderdialogVisible"
               width="30%">
      <el-form ref="folderForm"
               :model="folderForm"
               @keyup.enter.native="saveFolder()"
               :rules="rule">
        <el-form-item prop="folderName">
          <el-input v-model="folderForm.folderName"
                    placeholder="Enter folder name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="closeFolderDialog()"
                   size="small">{{$t('documents.Cancel')}}</el-button>
        <el-button type="primary"
                   size="small"
                   :disabled="saveDisabled"
                   @click="saveFolder()">{{$t('documents.Save')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="updateFileDialog.title"
               :close-on-click-modal="false"
               :show-close="false"
               :visible.sync="updateFileDialog.show"
               width="30%">
      <el-form @keyup.enter.native="updateProjectFile()">
        <el-form-item v-if="updateFileDialog.type==='Rename'">
          <el-input v-model="fileName"
                    placeholder="Enter file name"></el-input>
        </el-form-item>
        <el-form-item v-else
                      :label="$t('documents.Folder')">
          <el-select v-model="folderId"
                     clearable
                     size="mini">
            <el-option v-for=" i of folderList"
                       :key="i.FolderId"
                       :label="i.Name"
                       :value="i.FolderId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="updateFileDialog.show = false"
                   size="small">{{$t('documents.Cancel')}}</el-button>
        <el-button type="primary"
                   size="small"
                   @click="updateProjectFile()">{{$t('documents.Save')}}</el-button>
      </span>
    </el-dialog>
    <pdfPreview :showDialog="pdfPreview.show"
                :pdfFileName="pdfPreview.name"
                :url="pdfPreview.url"
                :showSendMail="pdfPreview.showSendMail"
                :id="pdfPreview.id"
                @closeDialog="handlePdfPreview">
    </pdfPreview>
    <photoDialog :showDialog="photoDialog.showDialog"
                 @closeDialog="hideBigPhoto()"
                 :url="photoDialog.url"
                 :isVideo="photoDialog.isVideo"></photoDialog>
    <UploadDoc :showDialog="uploadDialog.showDialog"
               :folderId="uploadDialog.folderId"
               :orderBy="sortBy+' '+sortValue"
               @closeDialog="closeUpload"></UploadDoc>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getProjectFile, deleteProjectFolderFile, saveFolders, getFolders, updateProjectFile } from '@/api/config'
import axios from 'axios'
import photoDialog from '@components/photo/photoDialog.vue'
import UploadDoc from '@components/uploading/uploadDoc'
import pdfPreview from '@/components/pdf/pdfPreview.vue'
import SortControl from '@components/common/sortBtnList'
export default {
  data () {
    const validateFolderName = async (rule, value, callback) => {
      if (value) {
        this.folderName = value
        callback()
      } else {
        return callback(new Error(this.$t('documents.FolderNameisrequired')))
      }
    }
    return {
      checkAll: false,
      isIndeterminate: false,
      loading: false,
      uploadDialog: {
        showDialog: false
      },
      checkList: [],
      checkIdList: [],
      list: [],
      photoDialog: {
        showDialog: false,
        url: '',
        isVideo: false
      },
      condition: {
        FileName: null,
        LoadFolders: true,
        PageIndex: 1,
        PageSize: 30
      },
      pdfPreview: {
        show: false,
        name: '',
        url: '',
        id: '',
        showSendMail: false
      },
      total: 0,
      sortType: [
        {
          name: this.$t('task.Name'),
          value: 'Name'
        }, {
          name: this.$t('task.CreatedOn'),
          value: 'CreatedOn'
        }],
      sortValue: 'desc',
      sortBy: 'CreatedOn',
      selectedFolder: null,
      folderId: null,
      folderName: null,
      saveFolderdialogVisible: false,
      folderCondition: {
        JobsiteId: null,
        PageIndex: 1,
        PageSize: 30
      },
      folderList: [],
      renameOrMoveList: [],
      fileId: null,
      fileName: null,
      updateFileDialog: {
        show: false,
        title: '',
        type: 'Rename'
      },
      dragging: null,
      saveDisabled: false,
      folderForm: {
        folderName: null
      },
      rule: {
        folderName: [{
          validator: validateFolderName,
          trigger: 'blur'
        }]
      }
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'documentsConditionOrderby']),
    folderDialogTitle () {
      return this.folderId === null ? this.$t('documents.NewFolder') : this.$t('documents.RenameFolder')
    }
  },
  created () {
    this.setDocumentsConditionOrderBy()
    this.getFileList()
  },
  mounted () {

  },
  watch: {
    checkIdList (to, from) {
      this.checkList = []
      if (to.length > 0) {
        this.checkList = this.list.filter(i => to.find(t => t === i.DocFileId)).map(q => ({ DocFileId: q.DocFileId, IsFolder: q.IsFolder, Name: q.Name }))
      }
    }
  },
  methods: {
    handleRenameDeleteCommand (command) {
      if (command.action === 1) {
        this.folderId = command.item.DocFileId
        this.folderName = command.item.Name
        this.folderForm.folderName = command.item.Name
        this.saveFolderdialogVisible = true
      }
      if (command.action === 2) {
        this.doDeleteDocumentAction([command.item])
      }
      if (command.action === 3) {
        this.fileId = command.item.DocFileId
        this.fileName = command.item.Name.substring(0, command.item.Name.lastIndexOf('.'))
        this.folderId = command.item.FolderId
        this.updateFileDialog.title = this.$t('documents.RenameFile')
        this.updateFileDialog.type = 'Rename'
        this.updateFileDialog.show = true
      }
      if (command.action === 4) {
        this.fileId = command.item.DocFileId
        this.fileName = command.item.Name.substring(0, command.item.Name.lastIndexOf('.'))
        this.folderId = command.item.FolderId
        this.updateFileDialog.title = this.$t('documents.MoveFile')
        this.updateFileDialog.type = 'Move'
        this.updateFileDialog.show = true
        this.getFolders()
      }
    },
    handleAddCommand (command) {
      if (command === '1') {
        this.openUpload()
      } else if (command === '2') {
        this.folderId = null
        this.folderForm.folderName = null
        this.saveFolderdialogVisible = true
      }
    },
    handleCheckAllChange (val) {
      this.checkIdList = val ? this.list.map(q => q.DocFileId) : []
      this.isIndeterminate = false
    },
    handleCheckedChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.list.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length
    },
    previewPdf (id, url, name) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('welcome.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
          'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
        }
      }).then((res) => {
        let blob = new Blob([res], {
          type: `application/pdf`
        })
        let objectUrl = URL.createObjectURL(blob)
        this.pdfPreview.show = true
        this.pdfPreview.name = name
        this.pdfPreview.url = objectUrl
        this.pdfPreview.id = id
      })
      loading.close()
    },
    handlePdfPreview (val) {
      this.pdfPreview.show = false
      this.pdfPreview.name = ''
      this.pdfPreview.url = ''
    },
    downloadDocuments () {
      let that = this
      if (this.checkList.length < 1) {
        this.$notify.info({
          title: this.$t('documents.PleaseSelectDocument')
        })
      } else {
        const loading = this.$loading({
          lock: true,
          text: this.$t('welcome.Loading'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        axios({
          method: 'Post',
          url: this.$config.baseURL + '/api/Attachments/DownloadFiles',
          data: { Files: this.checkList },
          responseType: 'blob',
          'headers': {
            'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
            'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
          }
        }).then((res) => {
          let blob = new Blob([res])
          const fileName = 'Document.zip'
          const link = document.createElement('a')// 创建a标签
          link.download = fileName
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(link.href) // 释放url
          document.body.removeChild(link)
          loading.close()
        }).catch((err) => {
          if (err.response.data.type.includes('application/json')) {
            let reader = new FileReader()
            reader.onload = function (event) {
              let content = reader.result
              let message = JSON.parse(content).Message
              that.$notify.closeAll()
              that.$notify.warning({
                title: message === 'Not Found' ? that.$t('photo.NotFound') : that.$t(message),
                showClose: false,
                duration: 1000
              })
            }
            reader.readAsText(err.response.data)
          } else {
            that.$notify.closeAll()
            that.$notify.warning({
              title: err.response.data.Message,
              showClose: false,
              duration: 1000
            })
          }
          loading.close()
        })
      }
    },
    doDeleteDocumentAction (items, callback) {
      let text = 'Are you sure you want to delete the selected items?'
      if (items.length === 1) {
        text = 'Are you sure you want to delete the ' + (items[0].IsFolder ? 'folder' : 'document') + ` '${items[0].Name}'?`
      }
      this.$confirm(text, this.$t('photo.TIPS'), {
        confirmButtonText: this.$t('photo.Yes'),
        cancelButtonText: this.$t('photo.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        deleteProjectFolderFile(items).then(res => {
          this.$refs.pagination.handleDelete(items.length)
          if (callback) {
            callback()
          }
        })
      }).catch(() => {
      })
    },
    deleteDocuments () {
      if (this.checkList.length < 1) {
        this.$notify.info({
          title: this.$t('documents.PleaseSelectDocument')
        })
      } else {
        this.doDeleteDocumentAction(this.checkList, () => {
          this.checkList = []
          this.checkAll = false
          this.isIndeterminate = false
        })
      }
    },
    closeUpload (needRefresh) {
      this.uploadDialog.showDialog = false
      if (needRefresh === true) {
        this.getFileList()
      }
    },
    openUpload () {
      this.uploadDialog.folderId = this.selectedFolder !== null ? this.selectedFolder.DocFileId : null
      this.uploadDialog.showDialog = true
    },
    sortList () {
      if (this.sortValue === 'asc') {
        this.sortValue = 'desc'
      } else {
        this.sortValue = 'asc'
      }
      this.sort()
    },
    sort () {
      this.condition.OrderBy = this.getDocumentsConditionOrderBy()
      this.saveDocumentsConditionOrderBy()
      this.getFileList()
    },
    getFileList () {
      this.loading = true
      this.condition.JobsiteId = this.jobsiteID
      this.condition.OrderBy = this.getDocumentsConditionOrderBy()
      getProjectFile(this.condition).then(res => {
        this.total = res.TotalCount
        res.Data.forEach(ele => {
          ele.CreatedOn = this.$config.formatDate(new Date(ele.CreatedOn), 'MM/dd/yyyy')
          ele.Type = this.$config.getFileType(ele.Name)
          ele.url = this.$config.baseURL + '/api/Attachments/' + ele.DocFileId
          ele.videoThumbUrl = ele.url
          if (ele.Type === 2) {
            ele.videoThumbUrl += '?getVideoThumbImg=true'
          } else if (ele.Type === 3) {
            if (ele.DocCoverFileId) {
              ele.docCoverUrl = this.$config.baseURL + '/api/Attachments/' + ele.DocCoverFileId
            }
          }
        })
        this.list = res.Data
        this.loading = false
        this.checkIdList = []
        this.checkAll = false
        this.isIndeterminate = false
      })
    },
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.getFileList()
    },
    handleDocumentClick (doc) {
      if (doc.IsFolder) {
        this.selectedFolder = doc
        this.condition.FileName = null
        this.condition.FolderId = doc.DocFileId
        this.condition.PageIndex = 1
        this.getFileList()
        return
      }
      if (doc.Type === 1 || doc.Type === 2) {
        this.photoDialog.showDialog = true
        this.photoDialog.url = doc.url
        this.photoDialog.isVideo = doc.Type === 2
      } else if (doc.Type === 3) {
        this.previewPdf(doc.DocFileId, doc.url, doc.Name)
      }
    },
    hideBigPhoto () {
      this.photoDialog.showDialog = false
      this.photoDialog.url = ''
      this.photoDialog.isVideo = false
    },
    saveFolder () {
      this.saveDisabled = true
      this.$refs['folderForm'].validate((valid) => {
        if (valid) {
          let data = {
            JobsiteId: this.jobsiteID,
            FolderId: this.folderId,
            Name: this.folderForm.folderName
          }
          saveFolders([data]).then((res) => {
            this.getFileList()
            this.saveFolderdialogVisible = false
            this.saveDisabled = false
          }).catch(() => {
            this.saveFolderdialogVisible = false
            this.saveDisabled = false
          })
        } else {
          this.saveDisabled = false
        }
      })
    },
    back () {
      this.selectedFolder = null
      this.condition.FolderId = null
      this.condition.PageIndex = 1
      this.getFileList()
    },
    getFolders () {
      this.folderCondition.JobsiteId = this.jobsiteID
      this.folderCondition.OrderBy = this.sortBy + ' ' + this.sortValue
      getFolders(this.folderCondition).then(res => {
        this.folderList = res.Data
        this.folderList.unshift({ 'FolderId': null, 'JobsiteId': this.jobsiteID, 'Name': this.$t('documents.NoFolder'), 'IsDeleted': false })
        this.updateFileDialog.show = true
      })
    },
    updateProjectFile () {
      if (this.fileName === null || this.fileName.trim().length === 0) {
        return
      }
      let data = {
        DocFileId: this.fileId,
        Name: this.fileName
      }
      if (this.folderId !== null && this.folderId.trim().length > 0) {
        data.FolderId = this.folderId
      }
      updateProjectFile([data]).then((res) => {
        this.getFileList()
        this.updateFileDialog.show = false
      }).catch(() => {
        this.updateFileDialog.show = false
      })
    },
    handleDragStart (e, item) {
      this.dragging = item
    },
    handleDragEnd (e, items) {
      this.dragging = null
    },
    handleDragOver (e) {
      e.dataTransfer.dropEffect = 'move'
    },
    handleDragEnter (e, item) {
      e.dataTransfer.effectAllowed = 'move'
    },
    handleDragDrop (e, item) {
      e.dataTransfer.dropEffect = 'move'
      if (this.dragging.DocFileId !== item.DocFileId && this.dragging.FolderId !== item.FolderId && this.dragging.IsFolder === false) {
        let dragIndex = this.list.indexOf(this.dragging)
        this.fileId = this.dragging.DocFileId
        this.fileName = this.dragging.Name.substring(0, this.dragging.Name.lastIndexOf('.'))
        this.folderId = item.FolderId
        let itemDiv = this.$refs['photobox' + dragIndex]
        if (itemDiv.length > 0) {
          itemDiv[0].parentElement.remove()
          this.updateProjectFile()
        }
      }
    },
    closeFolderDialog () {
      if (this.$refs['folderForm']) {
        this.$refs['folderForm'].clearValidate()
      }
      this.saveFolderdialogVisible = false
    },
    getDocumentsConditionOrderBySplit () {
      return ' '
    },
    getDocumentsConditionOrderBy () {
      return this.sortBy + this.getDocumentsConditionOrderBySplit() + this.sortValue
    },
    setDocumentsConditionOrderBy () {
      let arr = this.documentsConditionOrderby.split(this.getDocumentsConditionOrderBySplit())
      if (arr && arr.length === 2) {
        this.sortBy = arr[0]
        this.sortValue = arr[1]
      }
    },
    saveDocumentsConditionOrderBy () {
      this.$store.commit('setDocumentsConditionOrderby', this.condition.OrderBy)
    }
  },
  components: {
    UploadDoc,
    pdfPreview,
    photoDialog,
    SortControl
  }
}
</script>
<style lang="scss">
.el-message-box {
  width: 450px;
}
.photo-box {
  .el-checkbox {
    width: 100%;
    margin-top: 6px;
    .el-checkbox__input {
      position: absolute;
      top: 5px;
    }
    .el-checkbox__label {
      width: 90%;
      padding-left: 20px;
      span {
        display: block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #909399;
        &:first-child {
          color: #303133;
          font-size: 16px;
          margin-top: 4px;
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.list-box {
  width: 100%;
  flex: 1;
  height: 0;
  position: relative;
  .cube-box {
    box-sizing: border-box;
    width: 16.6%;
    padding: 0 8px;
    float: left;
    overflow: hidden;
    margin-bottom: 16px;
    .photo-box {
      padding: 8px;
      position: relative;
      background-color: #fff;
      overflow: hidden;
      border: 1px solid #ccc;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      .photo-img {
        height: 160px;
        width: 100%;
        background-color: #fff;
        cursor: pointer;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
        video {
          height: 100%;
          width: 100%;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }
        .videoPlayContent {
          cursor: pointer;
          width: 100%;
          height: 100%;
          position: relative;
          .videoPlayDiv {
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.4);
          }
          .videoPlay {
            background: url(../../../assets/image/play.png) no-repeat;
            background-position: 50% 50%;
            cursor: pointer;
            color: buttontext;
            width: 100%;
            height: 100%;
            display: inline-block;
          }
        }
      }
      .action-btn {
        position: absolute;
        right: 0px;
        bottom: 0;
        height: 38px;
        text-align: center;
        .el-button {
          border: none;
          background: none;
          color: #4193f6;
          font-size: 16px;
        }
        .el-link {
          font-size: 22px;
        }
      }
    }
  }
}

@media (max-width: 1120px) {
  .main {
    .list-box {
      .cube-box {
        width: 33.3%;
      }
    }
  }
}
</style>
